import { LoadingFour } from "@icon-park/svg";
import clsx from "clsx";
import { FC } from "react";
import Icon from "../Icon";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  inverted?: boolean;
  color?: "primary" | "neutral";
}

const Loader: FC<LoaderProps> = ({
  size = "sm",
  className,
  inverted,
  color = "primary",
}) => {
  const sizes = {
    sm: 16,
    md: 20,
    lg: 48,
  } as const;

  return (
    <span
      aria-hidden="true"
      className={clsx("inline-flex flex-none", className, {
        "text-primary-800": !inverted && color === "primary",
        "text-neutral-325": !inverted && color === "neutral",
        "text-neutral-0": inverted,
      })}
    >
      <Icon
        size={sizes[size]}
        icon={LoadingFour}
        className="animate-spin motion-reduce:[animation-duration:3s] flex-none"
      />
    </span>
  );
};

export default Loader;
